'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildStore;

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reactRouter = require('react-router');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _NotificationMiddleware = require('conversations-core/middleware/NotificationMiddleware');

var _NotificationMiddleware2 = _interopRequireDefault(_NotificationMiddleware);

var _PubNubHandlerMiddleware = require('conversations-core/middleware/PubNubHandlerMiddleware');

var _PubNubHandlerMiddleware2 = _interopRequireDefault(_PubNubHandlerMiddleware);

var _TypingMiddleware = require('conversations-core/middleware/TypingMiddleware');

var _TypingMiddleware2 = _interopRequireDefault(_TypingMiddleware);

var _TimeoutMiddleware = require('conversations-core/middleware/TimeoutMiddleware');

var _TimeoutMiddleware2 = _interopRequireDefault(_TimeoutMiddleware);

var _QueryParamMiddleware = require('conversations-core/middleware/QueryParamMiddleware');

var _QueryParamMiddleware2 = _interopRequireDefault(_QueryParamMiddleware);

var _WindowMiddleware = require('conversations-core/middleware/WindowMiddleware');

var _WindowMiddleware2 = _interopRequireDefault(_WindowMiddleware);

var _LastSeenMiddleware = require('conversations-core/middleware/LastSeenMiddleware');

var _LastSeenMiddleware2 = _interopRequireDefault(_LastSeenMiddleware);

var _NotificationMiddleware3 = require('ReduxMessenger/middleware/NotificationMiddleware');

var _NotificationMiddleware4 = _interopRequireDefault(_NotificationMiddleware3);

var _OfflineModeMiddleware = require('conversations-visitor-ui/middleware/OfflineModeMiddleware');

var _OfflineModeMiddleware2 = _interopRequireDefault(_OfflineModeMiddleware);

var _PublishingMiddleware = require('conversations-core/middleware/PublishingMiddleware');

var _PublishingMiddleware2 = _interopRequireDefault(_PublishingMiddleware);

var _PresenceMiddleware = require('conversations-core/middleware/PresenceMiddleware');

var _PresenceMiddleware2 = _interopRequireDefault(_PresenceMiddleware);

var _pubNubHandlers = require('conversations-core/pubNubHandlers');

var _pubNubHandlers2 = _interopRequireDefault(_pubNubHandlers);

var _prospectUtkSelectors = require('conversations-core/selectors/prospectUtkSelectors');

var _buildUsageTrackingMiddleware = require('conversations-visitor-ui/middleware/higherOrderMiddleware/buildUsageTrackingMiddleware');

var _buildUsageTrackingMiddleware2 = _interopRequireDefault(_buildUsageTrackingMiddleware);

var _reducers = require('conversations-visitor-ui/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _getCompose = require('conversations-lib/redux/getCompose');

var _getCompose2 = _interopRequireDefault(_getCompose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compose = (0, _getCompose2.default)();

function buildStore(initialState) {
  var isAdmin = false;

  var UsageTrackingMiddleware = (0, _buildUsageTrackingMiddleware2.default)((0, _prospectUtkSelectors.getMessagesUtk)(initialState));

  var middleware = [_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), (0, _LastSeenMiddleware2.default)(isAdmin), (0, _PubNubHandlerMiddleware2.default)(isAdmin, _pubNubHandlers2.default), (0, _TypingMiddleware2.default)(isAdmin), (0, _TimeoutMiddleware2.default)(isAdmin), (0, _NotificationMiddleware2.default)(isAdmin), _QueryParamMiddleware2.default, _WindowMiddleware2.default, _NotificationMiddleware4.default, _PublishingMiddleware2.default, _PresenceMiddleware2.default, _OfflineModeMiddleware2.default, UsageTrackingMiddleware];

  return (0, _redux.createStore)(_reducers2.default, initialState, compose(_redux.applyMiddleware.apply(undefined, middleware)));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/buildStore.js
// module id = 450
// module chunks = 0